const joinString =
  'join=dock||name,warehouseId&join=dock.warehouse&join=loadType||name,duration_min,direction&join=user&join=org&join=user.company';

// initial state
const state = {
  bookingData: {
    selectedWarehouse: {},
    selectedLoadType: {},
    selectedDock: {},
    selectedSlot: {},
    user: null,
    start: '',
    refNumber: null,
    ccEmails: [],
    customFields: []
  },
  responseMetaData: null
};

// getters
const getters = {
  bookingData(state) {
    return state.bookingData;
  }
};

// actions
const actions = {
  async getAppointments({ commit, rootState }, params = {}) {
    if (Number(params?.limit) === -1) {
      params.limit = '100000';
    }
    params.s = {
      ...params?.s,
      ...{
        userId: {
          $eq: this.$app.$me.id
        },
        type: {
          $ne: this.$app.novaCore.AppointmentType.Reserve
        },
        orgId: {
          $eq: rootState.App.org.id
        },
        'dock.warehouseId': {
          $eq: rootState.App.warehouse.id
        }
      }
    };
    let response = await axios.get(`appointment?${joinString}`, {
      params: params
    });
    let appointments = [];

    if (response && response.data) {
      commit('setAppointments', response.data.data);
      commit('setResponseMetaData', response.data);
      appointments = response.data.data;
    }

    return appointments;
  }
};

// mutations
const mutations = {
  setBookingData(state, { key, data }) {
    state.bookingData[key] = data;
  },
  setResponseMetaData(state, data) {
    state.responseMetaData = data;
  }
};

export default {
  namespaced: true,
  name: 'Appointments',
  state,
  getters,
  actions,
  mutations
};
